import { render, staticRenderFns } from "./horizontal-nav.vue?vue&type=template&id=d241a2c4"
import script from "./horizontal-nav.vue?vue&type=script&lang=js"
export * from "./horizontal-nav.vue?vue&type=script&lang=js"
import style0 from "./horizontal-nav.vue?vue&type=style&index=0&id=d241a2c4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports